export default __webpack_public_path__ + "static/nano_horz_color-2x-315fd2e2df735ba95d6d77a10be72626.png";